import service from './http';

// 获取第三方 token（微软）
export const apply = () => {
  return service.request({
    method: 'get',
    url: '/liberty/open.token',
  });
};
